// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import FieldDropdown from '../FieldDropdown';
import Checkbox from '../Checkbox';

class ModelsSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleUpdateField = this.handleUpdateField.bind(this);
  }

  handleUpdateField(event) {
    this.props.handleUpdateFilter('models', event.target.name);
  }
  
  render() {
    const { options, hasBrands, activeModels } = this.props

    return ( 
      <FieldDropdown
        fieldTitle="Modelo"
        customClasses="model-select only-desktop"
        dropdownCustomClasses="model-select__dropdown"
        disabled={!hasBrands}
      >
        <h4 className="filter-v2__dropdown-title">Modelo</h4>
        <div className="model-select__fields">
          <ul className="model-select__fields-list">
            { options.length > 0 && options.flat().map((model, index) => (
              <li key={`${model.title}-${index}`} className="filter-v2__checkbox-item">
                <Checkbox
                  name={model.title}
                  labelText={model.title}
                  handleChange={this.handleUpdateField}
                  checked={activeModels.includes(model.title)}
                />
              </li>
              )
            )}
          </ul>
        </div>
      </FieldDropdown>
    );
  }
}

ModelsSelect.defaultProps = {
  handleUpdateFilter: () => {},
  options: [],
  activeModels: [],
  hasBrands: false,
};

ModelsSelect.propTypes = {
  handleUpdateFilter: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.objectOf({
      title: PropTypes.string,
    })
  ),
  activeModels: PropTypes.arrayOf(),
  hasBrands: PropTypes.bool,
};

export default ModelsSelect;
